<template>
  <div class="min-h-screen bg-slate-50 font-sans">
    <header class="bg-white border-b border-slate-200 sticky top-0 z-50 shadow-sm">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-14 flex items-center justify-between">
        <div class="flex items-center gap-4">
          <!-- Logo Home Link -->
          <NuxtLink to="/" class="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <img src="/logo.png" class="h-8 w-auto" alt="ClaimReady" />
          </NuxtLink>
        </div>

        <div class="flex items-center gap-4">
          <!-- Currency Selector -->
          <ClientOnly>
            <USelectMenu v-model="preferredCurrency" :icon="selectedCurrencyIcon" :items="AVAILABLE_CURRENCIES"
              value-key="code" label-key="label" class="hidden sm:block" />
          </ClientOnly>


          <!-- Stats -->
          <div v-if="currentReport" class="flex items-center gap-3 text-sm">
            <div
              class="hidden sm:flex items-center px-3 py-1 bg-slate-100 rounded-full border border-slate-200 text-slate-600 font-medium whitespace-nowrap">
              <UIcon name="i-heroicons-square-3-stack-3d" class="mr-1.5" />
              {{currentReport.rooms.reduce((acc, r) => acc + r.items.length, 0)}} Items
            </div>
            <div
              class="flex items-center px-3 py-1 bg-emerald-50 rounded-full border border-emerald-200 text-emerald-700 font-bold whitespace-nowrap">
              <UIcon name="i-heroicons-banknotes" class="mr-1 text-emerald-600" />
              {{ formattedValue }}
            </div>
          </div>
        </div>
      </div>
    </header>

    <main class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <slot />
    </main>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'
import { useInventoryStore } from '~/stores/inventory'
import { computed } from 'vue'

const { preferredCurrency, AVAILABLE_CURRENCIES, formatCurrency } = useCurrency()

const route = useRoute()
const inventoryStore = useInventoryStore()
const selectedCurrencyIcon = computed(() => {
  return AVAILABLE_CURRENCIES.value.find(c => c.code === preferredCurrency.value)?.icon
})

const currentReport = computed(() => {
  // Only works if we are on a report page [id] where id is the report ID
  if (route.params.id) {
    return inventoryStore.getReport(route.params.id as string)
  }
  return null
})

const formattedValue = computed(() => {
  if (!currentReport.value) return formatCurrency(0)
  const total = currentReport.value.rooms.reduce((acc, r) => acc + r.items.reduce((s, i) => s + Number(i.value), 0), 0)
  return formatCurrency(total)
})
</script>
